<template>
    <collapse-box-decorator trigger="click">
        <template #default="{ bindings }">
            <button-text v-bind="bindings" :disabled="availableLeads.length === 0">
                <svg-icon :icon="AddIcon" />
                <span><slot /></span>
            </button-text>
        </template>
        <template #title>
            Welke lead?
        </template>
        <template #content>
            <collapse-option-container>
                <collapse-option
                    v-for="lead in availableLeads"
                    :key="lead.id.value"
                    @click="redirectToOrderCreate(lead)"
                >
                    <lead-team-block :lead="lead" />
                </collapse-option>
            </collapse-option-container>
        </template>
    </collapse-box-decorator>
</template>

<script lang="ts" setup>
    import AddIcon from '@keyvue/one-material-icons/icons/add.svg?component';

    import {
        ButtonText,
        CollapseOption,
        CollapseOptionContainer,
        CollapseBoxDecorator,
        SvgIcon,
    } from '@keyvue/one-ui';
    import { computed, inject } from 'vue';
    import type { ReactiveCollection } from '@composables/useClient';
    import { type Lead, Status } from '@keyvue/one-api-client';
    import type { Order } from '@keyvue/one-api-client-legacy';
    import LeadTeamBlock from '@components/Blocks/LeadTeamBlock.vue';
    import { useRouter, useRoute } from 'vue-router';
    import useLeadSecurity from '@composables/security/useLeadSecurity';

    const router = useRouter();
    const route = useRoute();
    const { forLead: leadSecurityForLead } = useLeadSecurity();

    const leadCollection = inject<ReactiveCollection<Lead>>('leadCollection');
    if (!leadCollection) throw new Error('leadCollection is not provided');

    const orders = inject<Order[]>('orders');
    if (!orders) throw new Error('orderCollection is not provided');

    const availableLeads = computed(() => {
        const leads = leadCollection.data.value;

        return leads
            .filter((lead) => leadSecurityForLead(lead).canViewDetail.value)
            .filter((lead) => lead.status.equals(Status.WON));
    });

    const redirectToOrderCreate = (lead: Lead) => {
        router.push({
            name: 'createOrder',
            params: {
                contactId: route.params.contactId,
                leadId: lead.id.value,
            },
        });
    };
</script>
